const successNotifications = {
  launchSubscriptionPrebillingSuccess: "Pre-billing was successfully launched",
  launchSubscriptionChargeAttempt: "Charge attempt was successfully launched",
  extendSubscriptionExpDateSuccess: "Expiration date was successfully extended",
  extendSubscriptionExpDateFail: "Expiration date wasn't successfully extended",
  importLicenseKeysSuccess: "{{count}} license keys successfully imported",
}

export default successNotifications;
